// Generated from SVG to Code Figma Plugin

export const ProductOriginalRatio = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.666 4H18.9993C19.5516 4 19.9993 4.44772 19.9993 5V8.33333" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M14.1107 14.222H10.7773C10.2251 14.222 9.77734 13.7743 9.77734 13.222V9.88867"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M19.9996 4L9.77734 14.2222" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M13 4L7 4C5.34315 4 4 5.34315 4 7L4 17C4 18.6569 5.34315 20 7 20L17 20C18.6569 20 20 18.6569 20 17L20 11"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
